export type UnitType = "length" | "area";
export type UnitSystem = "Metric" | "Imperial";

export const isMetric = (unitSystem: UnitSystem) => unitSystem == "Metric";

export const precisionMetric = "1.2-2";
export const precisionImperial = "1.3-3";

export const precision = (unitSsystem: UnitSystem) => {
  return isMetric(unitSsystem) ? precisionMetric : precisionImperial;
};

export const getUnitLabel = (unit: UnitType, unitSystem: UnitSystem): string => (isMetric(unitSystem) ? getMetricUnit(unit) : getImperialUnit(unit));

const getMetricUnit = (unit: UnitType) => (unit == "area" ? "mm²" : "mm");

const getImperialUnit = (unit: UnitType) => (unit == "area" ? "inch²" : "inch");
